import { css } from '@emotion/react';

export const helperLinkReset = css`
  color: inherit;
  text-decoration: none;
  transition-property: background-color, border-color, color, box-shadow;
  transition-duration: 0.25s;
  -webkit-tap-highlight-color: transparent;
`;
